export const numberFilter = number => {
    return typeof number === 'number' ? new Intl.NumberFormat('en-US').format(number) : 0
};

export const sortLocale = (locale, values, field = null) => {
    if (field) {
        return values.sort((first, second) => first[field].localeCompare(second[field], locale))
    }
    return values.sort((first, second) => first.localeCompare(second, locale))
};
